<template>
  <div class="campaginsControl">
    <div class="title" :class="[lang, isLinked ? 'linked' : '']">
      <span
        ><span v-if="!isLinked">📊 </span>{{ $t("dailyConnectionLimit") }}</span
      >
      <a-popover style="z-index: 98" trigger="click" v-model="step3Visiable">
        <template slot="content">
          <div class="popbox">
            <p
              class="main-tit"
              :class="[lang]"
              :style="{
                'text-align': lang == 'AR' ? 'right' : 'left',
              }"
            >
              {{ $t("step3TipTitle") }}
            </p>
            <div
              class="ptit"
              :class="[lang]"
              :style="{
                'text-align': lang == 'AR' ? 'right' : 'left',
              }"
            >
              <span :class="[lang]">{{ $t("step3TipCon") }}</span
              ><span :class="[lang]" class="txt-red">{{
                $t("step3TipCon1")
              }}</span>
            </div>

            <p
              class="main-tit main-tit2"
              :class="[lang]"
              :style="{
                'text-align': lang == 'AR' ? 'right' : 'left',
                'margin-top': '16px',
              }"
            >
              {{ $t("step3TipTitle2") }}
            </p>
            <div
              class="ptit"
              :class="[lang]"
              :style="{
                'text-align': lang == 'AR' ? 'right' : 'left',
              }"
            >
              <span :class="[lang]">{{ $t("step3TipCon2") }}</span>
            </div>
            <div
              class="btn-box"
              :style="{
                'text-align': lang == 'AR' ? 'right' : 'left',
              }"
            >
              <span :class="[lang]" class="btn-txt" @click="goStep3Link">{{
                $t("bindLinkAccTipBtn")
              }}</span
              ><span :class="[lang]">{{ $t("bindLinkAccTipBtnTxt") }}</span>
            </div>
          </div>
        </template>
        <a-icon
          type="question-circle"
          style="
            font-size: 14px;
            color: #0e756a;
            cursor: pointer;
            margin-left: 6px;
          "
        />
      </a-popover>
    </div>
    <!-- <div class="subTitle" :class="[lang]">
      {{ $t("dailyLimitSubtitle") }}
    </div> -->
    <div class="input-tip" :class="[lang]" v-show="showTipsInfo">
      <span class="input-tip-icon">💡</span>
      <span class="input-tip-text">
      {{ $t("newAccountLimitTip") }}
      </span>
    </div>

    <div class="limitBox">
      <LimitBox
        :value="dailyLimit"
        :min="1"
        :max="100"
        @change="handleLimitChange"
      ></LimitBox>
    </div>
    <!-- <div class="safeTips">
      <div class="title1" :class="[lang]">⚠️ {{ $t("safeTips") }}</div>
      <div class="cont" :class="[lang]">
        {{ $t("safeTipsContent") }}
      </div>
    </div> -->
    <div v-if="!isLtd" class="title" :class="[lang, isLinked ? 'linked' : '']">
      <span v-if="!isLinked"> ⭕️ </span>{{ $t("selectAllocationMode") }}
    </div>
    <div :class="[lang]" style="margin-bottom:12px"  class="input-tip" v-show="!isLtd && showTipsInfo">
      <span class="input-tip-icon">💡</span>
      <span class="input-tip-text">
      {{ $t("allocationModeTip") }}
      </span>
    </div>
    <allocation-options
      v-if="!isLtd"
      :allocationMode="allocationMode"
      :daily-limit="dailyLimit"
      :active-campaigns-count="campaignsCount"
      @change="handleAllocationChange"
    />
  </div>
</template>
<script>
import LimitBox from "@/components/limitBox";
import AllocationOptions from "@/components/allocationOptions";

export default {
  data() {
    return {
      //   allocationMode: 1,
      activeCampaigns: [],
      step3Visiable: false,
    };
  },
  props: {
    showTipsInfo:{
      type: Boolean,
      default: false,
    },
    dailyLimit: {
      type: Number,
      default: 24,
    },
    isLtd: {
      type: Boolean,
      default: false,
    },
    isLinked: {
      type: Boolean,
      default: false,
    },
    allocationMode: {
      type: Number,
      default: 1,
    },
    campaignsCount: {
      type: Number,
      default: 3,
    },
  },
  components: {
    LimitBox,
    AllocationOptions,
  },
  i18n: require("./i18n"),

  methods: {
    handleAllocationChange(val) {
      this.$emit("allocationChange", val);
    },
    goStep3Link() {
      window.open(
        "https://leadgeneration.tawk.help/article/linkedin-usage-restrictions-and-settings",
      );
    },
    handleLimitChange(value) {
      this.$emit("handleLimitChange", value);
    },
  },
};
</script>
<style lang="less" scoped>
.popbox {
  width: 551px;
  max-height: calc(100vh - 64px);
  overflow-y: auto;
  overflow-x: hidden;
  .main-tit {
    font-weight: bold;
    font-size: 16px;
    color: #0e756a;
    margin-bottom: 0;
  }
  .ptit {
    margin-top: 17px;
    font-size: 14px;
    color: #000000;
    user-select: none;
    .num {
      width: 19px;
      height: 19px;
      display: inline-block;
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
      line-height: 19px;
      text-align: center;
      margin-right: 7px;
      background: #0e756a;
      border-radius: 50%;
    }
    .rtl {
      margin-right: 0px;
      margin-left: 7px;
    }
    &-3 {
      display: flex;
      .num {
        min-width: 19px;
      }
      .con-3 {
        flex: 1;
        .txt-tip {
          color: #ff4d4f;
        }
      }
    }
  }
  .txt-red {
    color: #ff4d4f;
  }
  img {
    display: block;
    margin-top: 17px;
  }
  .search {
    // width: 375px;
    height: 47px;
  }
  .tips {
  }
  .btn-box {
    margin-top: 34px;
    color: #000;
    .btn-txt {
      color: #0e756a;
      cursor: pointer;
    }
  }
}
.campaginsControl {
  .limitBox {
    margin-top: 20px;
    width: 100px;
  }
  .title {
    font-size: 20px;
    font-weight: bold;
    margin-top: 30px;
    margin-bottom: 14px;
    color: #000;
  }
  .linked {
    font-size: 18px;
    margin-top: 25px;
    margin-bottom: 18px;
  }
  .subtitle {
    font-size: 14px;
    line-height: 20px;
    color: rgba(28, 38, 62, 0.52);
    margin-bottom: 20px;
  }

  .safeTips {
    border-radius: 10px;
    background-color: rgba(255, 246, 234, 1);
    font-size: 14px;
    font-family: PingFangSC-regular;
    border: 1px solid rgba(251, 192, 35, 1);
    margin-top: 18px;
    padding: 19px 17px;
    .title1 {
      height: 24px;
      line-height: 24px;
      color: rgba(16, 16, 16, 1);
      font-size: 17px;
      text-align: left;
      font-family: PingFangSC-regular;
      margin-bottom: 13px;
    }
    .cont {
      line-height: 20px;
      color: rgba(28, 38, 62, 0.52);
      font-size: 14px;
      text-align: left;
      font-family: PingFangSC-regular;
    }
  }
}
/deep/.input-tip {
  display:inline-block!important;
  margin-top: 0px!important;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1.6;

  .input-tip-icon {
    flex-shrink: 0;
    font-size: 14px;
  }

  .input-tip-text {
    flex: 1;

    .eye {
      font-size: 13px;
      margin: 0 2px;
    }

    .input-tip-bold {
      font-weight: 600;
      color: #1f1f1f;
      margin-right: 4px;
    }

    .input-tip-link {
      color: #0e756a;
      font-weight: 500;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
